/**
 * AdvertisingPlatform
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { Hagridv1FileMetaData } from '../models/Hagridv1FileMetaData';
import { HttpFile } from '../http/http';

/**
* Request to Upload the TOS file
*/
export class V1UploadTOSAgreementRequest {
    'metadata'?: Hagridv1FileMetaData;
    /**
    * The actual file.
    */
    'chunk'?: string;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "metadata",
            "baseName": "metadata",
            "type": "Hagridv1FileMetaData",
            "format": ""
        },
        {
            "name": "chunk",
            "baseName": "chunk",
            "type": "string",
            "format": "byte"
        }    ];

    static getAttributeTypeMap() {
        return V1UploadTOSAgreementRequest.attributeTypeMap;
    }

    public constructor() {
    }
}

